// extracted by mini-css-extract-plugin
export var content = "H_P";